var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("SearchableDocumentsList", {
    attrs: {
      query: _vm.query,
      companyId: _vm.company.id,
      currentUser: _vm.currentUser,
      outerFilterTouched: _vm.filtersTouched,
    },
    scopedSlots: _vm._u([
      {
        key: "filters",
        fn: function () {
          return [
            _c("ManagersMultiselect", {
              staticClass: "documents__multiselect",
              attrs: {
                value: _vm.selectedManagersIds,
                placeholder: "Select managers",
              },
              on: { input: _vm.onManagerSelected },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }